import React from "react";
import { Box, Checkbox, IconButton, Stack } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/Delete";
import { palette } from "../../../styles/theme";

export function SidebarItem({
  label,
  active,
  onClick,
  onDelete,
  onMoveUp,
  onMoveDown,
  visible,
  onToggleVisible,
  onMouseEnter,
  onMouseLeave,
  icon,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  onDelete?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  visible?: boolean;
  onToggleVisible?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  icon?: React.ReactNode;
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        px: 1,
        py: 0.75,
        borderRadius: "4px",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: active ? 600 : 500,
        color: active ? palette.brand.primary : "text.primary",
        opacity: visible === false ? 0.45 : 1,
        bgcolor: active ? palette.brand.paleEffect : "transparent",
        "&:hover": {
          bgcolor: active ? palette.brand.paleEffect : "action.hover",
          "& .layer-arrows": { opacity: 1 },
        },
      }}
    >
      {onToggleVisible !== undefined && (
        <Checkbox
          size="small"
          checked={visible !== false}
          onClick={(e) => {
            e.stopPropagation();
            onToggleVisible();
          }}
          sx={{ p: 0, mr: 0.5, "& .MuiSvgIcon-root": { fontSize: 16 } }}
        />
      )}
      {icon ? (
        <Box
          sx={{
            mr: 0.75,
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
            color: active ? palette.brand.primary : "text.secondary",
            "& .MuiSvgIcon-root": { fontSize: 17 },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
        }}
      >
        {label}
      </Box>
      {(onMoveUp || onMoveDown) && (
        <Stack
          direction="row"
          className="layer-arrows"
          sx={{ flexShrink: 0, opacity: 0, transition: "opacity 0.15s" }}
        >
          {onMoveUp && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onMoveUp();
              }}
              sx={{
                p: 0.25,
                color: "inherit",
                opacity: 0.6,
                "&:hover": { opacity: 1 },
              }}
            >
              <ArrowUpwardIcon sx={{ fontSize: 14 }} />
            </IconButton>
          )}
          {onMoveDown && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onMoveDown();
              }}
              sx={{
                p: 0.25,
                color: "inherit",
                opacity: 0.6,
                "&:hover": { opacity: 1 },
              }}
            >
              <ArrowDownwardIcon sx={{ fontSize: 14 }} />
            </IconButton>
          )}
        </Stack>
      )}
      {onDelete && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          sx={{
            flexShrink: 0,
            p: 0.25,
            color: active ? palette.brand.primary : "text.secondary",
            opacity: 0.6,
            "&:hover": { opacity: 1 },
          }}
        >
          <DeleteIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Stack>
  );
}
